import React, { useEffect, useState, Fragment, useContext } from 'react'
import BannerHeaderBand from './BannerHeaderBand'
import { StorageAccessor } from 'Utilities/LocalStorageUtility'
import GraphQLRequest from 'Utilities/GraphQLClient/GraphQLClient'
import { UserContext } from 'Contexts/UserContext/UserContext'
import useFeatureFlag from 'Hooks/useFeatureFlag/useFeatureFlag'

const Banners = ({ url, reserveBannerSpace }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [banners, setBanners] = useState(reserveBannerSpace ? [{ bannerType: { name: 'placeholder' } }] : [])
    const { context: userContext } = useContext(UserContext)
    let showLoyaltyRewardsBannerFlag = useFeatureFlag('Clutch_Loyalty_Beta_Site_Banner')

    useEffect(() => {
        async function FetchBanners() {
            try {
                const CACHENAME = "websiteBanners"
                let cachedBanners = StorageAccessor.sessionStorage.getObj(CACHENAME);
                if (!cachedBanners && !userContext.isBot()) {
                    const query = `query GetBanners{
                        banners: activeBanners {
                            id,
                            title,
                            description,
                            mobileTitle,
                            promoCode,
                            promoCodeDescription
                            startDate
                            endDate,
                            url
                            linkText
                            bannerType {
                                id
                                name
                            }
                        }
                    }`
                    const response = await GraphQLRequest(
                        url,
                        query,
                        null
                    )
                    cachedBanners = response?.banners ?? []

                    StorageAccessor.sessionStorage.setObj(CACHENAME, cachedBanners, 20);
                    setBanners(cachedBanners)
                } else if (!cachedBanners) {
                    cachedBanners = []
                }
                if (shouldHideLoyaltyBanner(showLoyaltyRewardsBannerFlag, userContext)) {
                    setBanners(cachedBanners.filter(x => !x?.title?.includes('Speedway Motors Rewards')));
                } else {
                    setBanners(cachedBanners)
                }

            }
            catch (err) {
                console.error(err)
                setBanners([])
            }
        }

        FetchBanners()
    }, [userContext.hydrated, showLoyaltyRewardsBannerFlag])



    if (banners && banners.length === 0) {
        return null
    }




    return banners.map((banner, i) => {
        return (
            <Fragment key={banner.id}>
                <Banner {...banner} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} index={i} />
            </Fragment>
        )
    })
}

function shouldHideLoyaltyBanner(showLoyaltyRewardsBannerFlag, userContext) {
    if (!showLoyaltyRewardsBannerFlag || !userContext.hydrated) {
        return true
    }

    let hideLoyaltyBanner = !(userContext?.isLoyaltyBetaUser && !userContext?.isLoyaltyRegisteredUser)
    if (typeof window !== 'undefined') {
        if (window.location.pathname.includes('/account/loyalty')) {
            hideLoyaltyBanner = true
        }
    }
    return hideLoyaltyBanner
}

const Banner = ({ isModalOpen, setIsModalOpen, id, title, description, promoCode, promoCodeDescription, bannerType, startDate, endDate, mobileTitle, url, linkText, index }) => {

    switch (bannerType.name) {
        case 'placeholder':
            {
                return <BannerHeaderBand.PlaceholderBanner />
            }
            break
        case 'promotion':
            {
                return (
                    <BannerHeaderBand.PromotionBanner
                        id={id}
                        title={title}
                        mobileTitle={mobileTitle}
                        description={description}
                        promoCode={promoCode}
                        promoCodeDescription={promoCodeDescription}
                        isModalOpen={isModalOpen}
                        url={url}
                        linkText={linkText}
                        setIsModalOpen={setIsModalOpen}
                        startDate={startDate}
                        endDate={endDate}
                        index={index}
                    />
                )
            }
            break
        case 'maintenance':
            return (
                <BannerHeaderBand.MaintenanceBanner
                    id={id}
                    title={title}
                    description={description}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    startDate={startDate}
                    endDate={endDate}
                    mobileTitle={mobileTitle}
                    index={index}
                />
            )
            break
        default:
            return false;
            break
    }
}
export default Banners
